// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.5 1.33981L0 6.92805V20H2V8.07194L9.5 3.66018L16.2299 7.61895L17.244 5.89508L9.5 1.33981Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M4 23V11.4172L13.4994 17.1689L23 11.4222V23H4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 8.99999V9.08474L13.5 14.8311L4 9.07921V8.99999H23Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mark-as-unread-filled')
export default class MarkAsUnreadFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mark-as-unread-filled',
    }
  }
}
